import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable()
export class SettingsProvider {
  constructor(public storage: Storage, public platform: Platform) {
    // console.log('Hello UserSettingsProvider Provider');
  }

  async get(property) {
    await this.platform.ready();
    try {
      return await this.storage.get(property);
    } catch (error) {
      //property does not exist set it to default
      console.error(error);
      return await this.storage.set(property, '');
    }
  }

  async set(property, val) {
    await this.platform.ready();
    try {
      return await this.storage.set(property, val);
    } catch (error) {
      //property does not exist set it to default
      console.error(error);
    }
  }
}
